import {Box, Grid, Pillar} from '@primer/react-brand'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {renderWithoutParagraphs} from '../../../../utils'
import type {IntroSectionProps} from '../types'
import baseStyles from '../../../../styles/base.module.css'

type Props = Pick<IntroSectionProps, 'introPillars'>

export function IntroPillars({introPillars}: Props) {
  if (!introPillars || introPillars.length === 0) return null

  return (
    <Box className={baseStyles.greenBorderBottom}>
      <Grid columnGap="none" className={baseStyles.gridContent}>
        {introPillars.map(item => {
          const IconComponent = item.fields.icon ? getPrimerIcon(item.fields.icon) : null
          return (
            /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
            <Grid.Column key={item.sys.id} span={{medium: 4}} className="gridColumn">
              <Box
                className={baseStyles.cardGridItem}
                padding={{narrow: 24, regular: 40, wide: 64}}
                borderWidth="thin"
                borderColor="muted"
              >
                <Pillar>
                  {IconComponent ? <Pillar.Icon icon={<IconComponent />} /> : null}
                  {item.fields.heading && (
                    <Pillar.Heading>{renderWithoutParagraphs(item.fields.heading)}</Pillar.Heading>
                  )}
                  {item.fields.description && (
                    <Pillar.Description>{renderWithoutParagraphs(item.fields.description)}</Pillar.Description>
                  )}
                </Pillar>
              </Box>
            </Grid.Column>
          )
        })}
      </Grid>
    </Box>
  )
}
